import { render, staticRenderFns } from "./DisplayApproved.vue?vue&type=template&id=0390a29e"
import script from "./DisplayApproved.vue?vue&type=script&lang=js"
export * from "./DisplayApproved.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports